import styled from 'styled-components'
import ReactSelect from 'react-select'
import { Theme } from 'styles/Themes'
import responsiveSize from 'helper/responsiveSize'

interface IStyleProps {
  small?: boolean
  xsmall?: boolean
  large?: boolean
  error?: string | undefined
  styles?: any
  isSelected?: boolean
  marginRight?: number
  disabled?: boolean
}

export const Select = styled(ReactSelect)`
  margin-left: 0.5px;
  .Select__control {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    margin-right: ${(props: IStyleProps) => {
      if (props.marginRight) return `${props.marginRight}px`
      return '0'
    }};
    height: 40px;
    width: ${(props: IStyleProps) => {
      if (props.xsmall) return `84px`
      if (props.small) return `90px`
      if (props.large) return `144px`
      return `252px`
    }};
    padding-left: 7px;
    background: ${(props: IStyleProps) =>
      props.disabled ? Theme.pallete.QUATERNARY : Theme.pallete.SECONDARY};
    border: ${(props: IStyleProps) =>
      props.error
        ? '1px solid #f60665'
        : props.disabled
        ? 0
        : '1px solid #cccccc'};

    box-sizing: border-box;
    &:hover {
      border: 1px solid #cccccc;
      outline: hidden;
      background-color: rgb(245, 245, 245);
    }
    color: black !important;
    @media only screen and (min-width: 1441px) {
      height: 45px;
      width: ${(props: IStyleProps) => {
        if (props.xsmall) return `94px`
        if (props.small) return `101px`
        if (props.large) return `162px`
        return `284px`
      }};
      font-size: 13px;
    }
  }
  .react-select__option {
    box-shadow: 0 0 0 1px black;
    outline: hidden;
    &:hover {
      outline: hidden;
    }
  }
  .Select__indicator-separator {
    display: none;
  }
  .Select__indicator {
    color: #9c948c;
    padding-right: 15px;
  }
  .Select__menu {
    position: relative;
    background-color: #fefefe;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    text-align: left;
    box-sizing: border-box;
    z-index: 3;
    margin-top: 2px;
    border-radius: 5px;
    max-width: ${(props: IStyleProps) => {
      if (props.xsmall) return `94px`
      if (props.small) return `100px`
      if (props.large) return `154px`
      return `262px`
    }};
    @media only screen and (min-width: 1441px) {
      width: ${(props: IStyleProps) => {
        if (props.xsmall) return `94px`
        if (props.small) return `101px`
        if (props.large) return `162px`
        return `284px`
      }};
      font-size: 13px;
    }
  }

  .Select__single-value--is-disabled {
    color: rgb(84, 84, 84);
  }

  .Select__option {
    padding-left: ${responsiveSize.responsiveWidth(
      Theme.sizes.SELECTS.PADDING.SECONDARY
    )};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    padding: ${`${responsiveSize.responsiveWidth(
      Theme.sizes.SELECTS.PADDING.TERTIARY
    )} ${responsiveSize.responsiveWidth(
      Theme.sizes.SELECTS.PADDING.QUATERNARY
    )}`};
    text-align: left;
    overflow: hidden;
    height: 40px;
    width: ${(props: IStyleProps) => {
      if (props.xsmall) return `84px`
      if (props.small) return `90px`
      if (props.large) return `144px`
      return `252px`
    }};
    color: black !important;
    &:hover {
      background-color: rgb(245, 245, 245);
      color: black;
    }
    @media only screen and (min-width: 1441px) {
      width: ${(props: IStyleProps) => {
        if (props.xsmall) return `94px`
        if (props.small) return `101px`
        if (props.large) return `162px`
        return `284px`
      }};
      height: 45px;
      font-size: 13px;
    }
  }
`

export const SelectContainer = styled.div`
  position: relative;
  /* height: 72px; */
`

export const InputError = styled.div`
  font-family: ${Theme.fontFamily.PRIMARY};
  position: absolute;
  bottom: 0px;
  transform: translateY(100%);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: start;
  box-sizing: border-box;
  padding: ${`${responsiveSize.responsiveWidth(
    Theme.sizes.SELECTS.PADDING.QUINARY
  )} ${responsiveSize.responsiveWidth(Theme.sizes.SELECTS.PADDING.SECONDARY)}`};
  width: ${(props: IStyleProps) => {
    if (props.xsmall) return `84px`
    if (props.small) return `90px`
    if (props.large) return `144px`
    return `252px`
  }};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #d61212;
  @media only screen and (min-width: 1441px) {
    width: ${(props: IStyleProps) => {
      if (props.xsmall) return `94px`
      if (props.small) return `101px`
      if (props.large) return `162px`
      return `284px`
    }};
    font-size: 13px;
  }
`
export const Span = styled.span`
  position: absolute;
  left: 0px;
  top: -11px;
  z-index: 2;
  color: black;
  font-family: ${Theme.fontFamily.SECONDARY};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  height: 20px;
  padding: 2px 6px;
  border-radius: 10px;
  background: ${Theme.pallete.SECONDARY};
  @media only screen and (min-width: 1441px) {
    font-size: 13px;
  }
`
